module.exports = __webpack_public_path__ + "static/media/brand-refresh-warning-circle.7392d8d4.svg";